module.exports = __webpack_public_path__ + "img/bank_23.33ba8df4.png";